import { Formik, Form } from "formik";
import { useMemo, useState } from "react";
import { Button, Modal } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import DatePicker from "react-datepicker";
import Icon from "../../../controls/Icon";
import { Alert } from "react-bootstrap";

const ManageFilteredInstances = ({
    show,
    dateFormat,
    onClose,
    formInstances
}) => {
    const [translate] = useTranslation();

    const [dueDate, setDueDate] = useState(null);
    const [expiryDate, setExpiryDate] = useState(null);

    const renderAlert = useMemo(() => {
        return <Alert variant="warning" className="mb-3">
            <label className="fw-bold d-block">{translate("OTM_MANAGE_FILTERED_FORMS_WARNING", { length: formInstances.length })}</label>
        </Alert>;
    }, [formInstances, translate]);

    const renderForm = useMemo(() => {
        return <Formik onSubmit={onClose} enableReinitialize>
            <Form className="flex-grow-1 d-flex flex-column">
                <Modal.Header>
                    <label className="h5">{translate("OTM_MANAGE_FILTERED_FORMS")}</label>
                </Modal.Header>

                <Modal.Body>
                    {renderAlert}
                    <div className="row mt-n3 align-items-start">
                        <div className='col-12 col-lg-6 mt-3'>
                            <label className="form-label h6 d-block">{translate("OTM_UPDATE_DUE_DATES")}</label>
                            <div className="d-flex flex-wrap-1 align-items-center date-picker-w-100">
                                <DatePicker
                                    selected={dueDate}
                                    onChange={(newDate) => {
                                        setDueDate(newDate)
                                    }}
                                    showTimeSelect
                                    dateFormat={dateFormat}
                                    className="form-control"
                                />
                                <Button
                                    variant="outline-danger"
                                    className="ms-2 p-0 border-0"
                                    onClick={() => { setDueDate(null) }}
                                    title={translate("Clear")}
                                ><Icon icon="Clear" className="d-block" /></Button>
                            </div>
                        </div>
                        <div className='col-12 col-lg-6 mt-3'>
                            <label className="form-label h6 d-block">{translate("OTM_UPDATE_EXPIRY_DATES")}</label>
                            <div className="d-flex flex-wrap-1 align-items-center date-picker-w-100">
                                <DatePicker
                                    selected={expiryDate}
                                    onChange={(newDate) => {
                                        setExpiryDate(newDate)
                                    }}
                                    showTimeSelect
                                    dateFormat={dateFormat}
                                    className="form-control"
                                />
                                <Button
                                    variant="outline-danger"
                                    className="ms-2 p-0 border-0"
                                    onClick={() => { setExpiryDate(null) }}
                                    title={translate("Clear")}
                                ><Icon icon="Clear" className="d-block" /></Button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button size='sm' variant='primary' onClick={onClose}>{translate('OTM_SAVE')} </Button>
                    <Button size='sm' variant='secondary' onClick={onClose}>{translate('OTM_CANCEL')} </Button>
                </Modal.Footer>
            </Form>
        </Formik>
    }, [renderAlert, onClose, dateFormat, dueDate, expiryDate, translate]);

    return <Modal
        size={'lg'}
        show={show}
        backdrop={'static'}>
        {renderForm}
    </Modal>
}

export default ManageFilteredInstances;